<template>
  <div class="c-checkbox">
    <input
      v-if="!isHeaderLine"
      type="checkbox"
      :id="'product_' + product.id"
      :value="product.id"
      @change="handleChange"
      :checked="isSelected(product.id)"
      :disabled="isRequired"
    />
    <label :for="'product_' + product.id">{{ product.title }}</label>
  </div>
</template>

<script>
import productSetup from "./product-control-setup";

export default {
  ...productSetup,
};
</script>
